/**
 * An object to save the count of action elements, e.g. for material
 */
export interface ITableDataSetActionFieldCount {
    /** Identifier of of the action section */
    identifier: string;
    /** Optional also the name string of the action section */
    name?: string;
    /** The number of items added */
    fieldCount: number;
}

export class TableDataSetActionFieldCount implements ITableDataSetActionFieldCount {
    public identifier: string;
    public name?: string;
    public fieldCount: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableDataSetActionFieldCount);
    constructor(obj?: any) {
        this.identifier = obj && obj.identifier || '';
        this.name = obj && obj.name || undefined;
        this.fieldCount = obj && obj.fieldCount || 0;
    }
}
